module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.offlineSetting),
      expression: "!offlineSetting"
    }],
    staticClass: "callout callout-info"
  }, [_c('h4', [_vm._v("Device Offline !")]), _vm._v(" "), _c('p', [_vm._v("The parameters of the device could not be set.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowSos),
      expression: "isShowSos"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Duress Alarm Setting")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    class: _vm.offlineSetting ? 'btn btn-box-tool' : 'btn btn-box-tool disabled',
    attrs: {
      "type": "button",
      "data-target": "#modal-duress-alarm-setting"
    },
    on: {
      "click": _vm.toSetDuressAlarmSetting
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder (alias)"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body parameter-setting-box-body"
  }, [_c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("Status:  ")]), _vm._v(_vm._s(_vm.settingData.alarmsetting.isOpen ? 'On' : 'Off'))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("SOS Code:  ")]), _vm._v("7890")]), _vm._v(" "), _c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("SOS Message Content:  ")]), _vm._v(_vm._s(_vm.settingData.alarmsetting.text ? _vm.settingData.alarmsetting.text : '(empty)'))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Customize Home Arm function")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    class: _vm.offlineSetting ? 'btn btn-box-tool' : 'btn btn-box-tool disabled',
    attrs: {
      "type": "button",
      "data-target": "#modal-customize-homearm"
    },
    on: {
      "click": _vm.toSetHomeArmFunction
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder (alias)"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body parameter-setting-box-body"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('span', {
    staticClass: "cust-homearm-plugin"
  }, [_vm._v("PIR Sensor:  ")]), _vm._v(_vm._s(this.pirNameList))]), _vm._v(" "), _c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('span', {
    staticClass: "cust-homearm-plugin"
  }, [_vm._v("Door/Window Sensor:  ")]), _vm._v(_vm._s(this.doorNameList))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Entry Delay")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_vm._m(3), _vm._v(" "), _c('button', {
    class: _vm.offlineSetting ? 'btn btn-box-tool' : 'btn btn-box-tool disabled',
    attrs: {
      "type": "button",
      "data-target": "#modal-entry-delay"
    },
    on: {
      "click": _vm.toSetEntryDelay
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder (alias)"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body parameter-setting-box-body"
  }, [_c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("Delay Time:  ")]), _vm._v(_vm._s(this.settingData.entrydelaytime > 0 ? this.settingData.entrydelaytime + 's' : 'No delay'))]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('span', {
    staticClass: "cust-homearm-plugin"
  }, [_vm._v("PIR Sensor:  ")]), _vm._v(_vm._s(this.entrypirNameList))]), _vm._v(" "), _c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('span', {
    staticClass: "cust-homearm-plugin"
  }, [_vm._v("Door/Window Sensor:  ")]), _vm._v(_vm._s(this.entrydoorNameList))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Exit Delay")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_vm._m(5), _vm._v(" "), _c('button', {
    class: _vm.offlineSetting ? 'btn btn-box-tool' : 'btn btn-box-tool disabled',
    attrs: {
      "type": "button",
      "data-target": "#modal-exit-delay"
    },
    on: {
      "click": _vm.toSetExitDelay
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder (alias)"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body parameter-setting-box-body"
  }, [_c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("Delay Time:  ")]), _vm._v(_vm._s(this.settingData.exitdelaytime > 0 ? this.settingData.exitdelaytime + 's' : 'No delay'))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Siren Duration")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_vm._m(6), _vm._v(" "), _c('button', {
    class: _vm.offlineSetting ? 'btn btn-box-tool' : 'btn btn-box-tool disabled',
    attrs: {
      "type": "button",
      "data-target": "#modal-siren-duration"
    },
    on: {
      "click": _vm.toSetSirenDuration
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder (alias)"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body parameter-setting-box-body"
  }, [_c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("Time:  ")]), _vm._v(_vm._s(this.settingData.sirentime > 0 ? this.settingData.sirentime + 'min' : 'Silent'))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Select Timezone")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_vm._m(7), _vm._v(" "), _c('button', {
    class: _vm.offlineSetting ? 'btn btn-box-tool' : 'btn btn-box-tool disabled',
    attrs: {
      "type": "button",
      "data-target": "#modal-select-timezone"
    },
    on: {
      "click": _vm.toSetSelectTimezon
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder (alias)"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body parameter-setting-box-body"
  }, [_c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("Timezone:  ")]), _vm._v(_vm._s(this.settingData.timezone))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "parameter-setting-advanced-title"
  }, [_vm._v("Advanced Settings")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Restart the Device")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    class: _vm.offlineSetting ? 'btn btn-box-tool' : 'btn btn-box-tool disabled',
    attrs: {
      "type": "button",
      "data-target": "#modal-restart-device"
    },
    on: {
      "click": _vm.toSetRestartDevice
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder (alias)"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-duress-alarm-setting"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Password for Duress Alarm")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "alarm_setting_password",
      "placeholder": "Keep the current password"
    },
    domProps: {
      "value": _vm.settingData.alarmsetting.password
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Custom the SOS message")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "id": "alarm_setting_text",
      "placeholder": "Content sent when duress alarm activated"
    },
    domProps: {
      "value": _vm.settingData.alarmsetting.text
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSetDuressAlarm
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-customize-homearm"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', [_c('p', {
    staticClass: "device-setting-modal-plugin-title"
  }, [_vm._v("The official accessory")]), _vm._v(" "), _c('div', [_vm._m(11), _vm._v(" "), (_vm.pirData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pirData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "id": index + '_pir_home_switch',
        "type": "checkbox",
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2), _vm._v(" "), _c('div', [_vm._m(12), _vm._v(" "), (_vm.doorData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.doorData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "id": index + '_door_home_switch',
        "type": "checkbox",
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "device-setting-modal-plugin-title"
  }, [_vm._v("Third party accessory")]), _vm._v(" "), _c('div', [_vm._m(13), _vm._v(" "), (_vm.otherpirData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._l((_vm.otherpirData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "id": index + '_other_pir_home_switch',
        "type": "checkbox",
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2), _vm._v(" "), _c('div', [_vm._m(14), _vm._v(" "), (_vm.otherdoorData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._l((_vm.otherdoorData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "id": index + '_other_door_home_switch',
        "type": "checkbox",
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSetHomeAlarm
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-entry-delay"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "firmware-version-update"
  }, [_c('span', {}, [_vm._v("Delay Time:")]), _vm._v(" "), _c('select', {
    staticClass: "firmware-up-select",
    attrs: {
      "id": "entry_delay_time"
    },
    domProps: {
      "value": _vm.getDelayTime(_vm.settingData.entrydelaytime)
    }
  }, [_c('option', [_vm._v("No Delay")]), _vm._v(" "), _c('option', [_vm._v("10s")]), _vm._v(" "), _c('option', [_vm._v("20s")]), _vm._v(" "), _c('option', [_vm._v("30s")]), _vm._v(" "), _c('option', [_vm._v("40s")]), _vm._v(" "), _c('option', [_vm._v("50s")]), _vm._v(" "), _c('option', [_vm._v("60s")]), _vm._v(" "), _c('option', [_vm._v("70s")]), _vm._v(" "), _c('option', [_vm._v("80s")]), _vm._v(" "), _c('option', [_vm._v("90s")])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "device-setting-modal-plugin-title"
  }, [_vm._v("The official accessory")]), _vm._v(" "), _c('div', [_vm._m(16), _vm._v(" "), (_vm.pirData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pirData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "id": index + '_pir_entry_switch',
        "type": "checkbox",
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2), _vm._v(" "), _c('div', [_vm._m(17), _vm._v(" "), (_vm.doorData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.doorData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "type": "checkbox",
        "id": index + '_door_entry_switch',
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "device-setting-modal-plugin-title"
  }, [_vm._v("Third party accessory")]), _vm._v(" "), _c('div', [_vm._m(18), _vm._v(" "), (_vm.otherpirData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._l((_vm.otherpirData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "type": "checkbox",
        "id": index + '_other_pir_entry_switch',
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2), _vm._v(" "), _c('div', [_vm._m(19), _vm._v(" "), (_vm.otherdoorData.length <= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name device-setting-modal-plugin-id"
  }, [_vm._v("No accessories")])]) : _vm._l((_vm.otherdoorData), function(item, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticClass: "col-xs-10 control-label agent-edit-modal-name"
    }, [_vm._v(_vm._s(item.name)), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "device-setting-modal-plugin-id"
    }, [_vm._v(" "), _c('span', [_vm._v("( ")]), _c('span', [_vm._v(_vm._s(item.id))]), _c('span', [_vm._v(" )")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 modal-parameter-setting-switch"
    }, [_c('input', {
      staticClass: "switch-checkbox",
      attrs: {
        "type": "checkbox",
        "id": index + '_other_door_entry_switch',
        "checked": "checked",
        "data-on-color": "info",
        "data-off-color": "warning"
      }
    })])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoSetEntryDelay
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-exit-delay"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "firmware-version-update"
  }, [_c('span', {}, [_vm._v("Delay Time:")]), _vm._v(" "), _c('select', {
    staticClass: "firmware-up-select",
    attrs: {
      "id": "exit_delay_time"
    },
    domProps: {
      "value": _vm.getDelayTime(_vm.settingData.exitdelaytime)
    }
  }, [_c('option', [_vm._v("No Delay")]), _vm._v(" "), _c('option', [_vm._v("10s")]), _vm._v(" "), _c('option', [_vm._v("20s")]), _vm._v(" "), _c('option', [_vm._v("30s")]), _vm._v(" "), _c('option', [_vm._v("40s")]), _vm._v(" "), _c('option', [_vm._v("50s")]), _vm._v(" "), _c('option', [_vm._v("60s")]), _vm._v(" "), _c('option', [_vm._v("70s")]), _vm._v(" "), _c('option', [_vm._v("80s")]), _vm._v(" "), _c('option', [_vm._v("90s")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoSetExitDelay
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-siren-duration"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "firmware-version-update"
  }, [_c('span', {}, [_vm._v("Ringing Time:")]), _vm._v(" "), _c('select', {
    staticClass: "firmware-up-select",
    attrs: {
      "id": "siren_time"
    },
    domProps: {
      "value": _vm.getSirenTime(_vm.settingData.sirentime)
    }
  }, [_c('option', [_vm._v("Silent")]), _vm._v(" "), _c('option', [_vm._v("1min")]), _vm._v(" "), _c('option', [_vm._v("2min")]), _vm._v(" "), _c('option', [_vm._v("3min")]), _vm._v(" "), _c('option', [_vm._v("4min")]), _vm._v(" "), _c('option', [_vm._v("5min")]), _vm._v(" "), _c('option', [_vm._v("10min")]), _vm._v(" "), _c('option', [_vm._v("15min")]), _vm._v(" "), _c('option', [_vm._v("20min")]), _vm._v(" "), _c('option', [_vm._v("25min")]), _vm._v(" "), _c('option', [_vm._v("30min")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoSetSirenTime
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-select-timezone"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "firmware-version-update"
  }, [_c('span', {}, [_vm._v("Time Zone:")]), _vm._v(" "), _c('select', {
    staticClass: "device-setting-select",
    attrs: {
      "id": "select_timezone"
    },
    domProps: {
      "value": _vm.settingData.timezone
    }
  }, [_c('option', [_vm._v("Europe/London")]), _vm._v(" "), _c('option', [_vm._v("Europe/Lisbon")]), _vm._v(" "), _c('option', [_vm._v("Europe/Madrid")]), _vm._v(" "), _c('option', [_vm._v("Europe/Amsterdam")]), _vm._v(" "), _c('option', [_vm._v("Europe/Helsinki")]), _vm._v(" "), _c('option', [_vm._v("Europe/Mariehamn")]), _vm._v(" "), _c('option', [_vm._v("Europe/Oslo")]), _vm._v(" "), _c('option', [_vm._v("Europe/Copenhagen")]), _vm._v(" "), _c('option', [_vm._v("Europe/Paris")]), _vm._v(" "), _c('option', [_vm._v("Europe/Stockholm")]), _vm._v(" "), _c('option', [_vm._v("Europe/Zurich")]), _vm._v(" "), _c('option', [_vm._v("Europe/Berlin")]), _vm._v(" "), _c('option', [_vm._v("Europe/Busingen")]), _vm._v(" "), _c('option', [_vm._v("Europe/Vienna")]), _vm._v(" "), _c('option', [_vm._v("Europe/Rome")]), _vm._v(" "), _c('option', [_vm._v("Europe/Vatican")]), _vm._v(" "), _c('option', [_vm._v("Europe/Athens")]), _vm._v(" "), _c('option', [_vm._v("Europe/Warsaw")]), _vm._v(" "), _c('option', [_vm._v("Europe/Kiev")]), _vm._v(" "), _c('option', [_vm._v("Europe/Moscow")]), _vm._v(" "), _c('option', [_vm._v("Europe/Prague")]), _vm._v(" "), _c('option', [_vm._v("Europe/Bratislava")]), _vm._v(" "), _c('option', [_vm._v("Europe/Ljubljana")]), _vm._v(" "), _c('option', [_vm._v("Europe/Istanbul")]), _vm._v(" "), _c('option', [_vm._v("Africa/Cairo")]), _vm._v(" "), _c('option', [_vm._v("Africa/Johannesburg")]), _vm._v(" "), _c('option', [_vm._v("Asia/Jerusalem")]), _vm._v(" "), _c('option', [_vm._v("Asia/Riyadh")]), _vm._v(" "), _c('option', [_vm._v("Asia/Dubai")]), _vm._v(" "), _c('option', [_vm._v("Asia/Tehran")]), _vm._v(" "), _c('option', [_vm._v("Asia/Karachi")]), _vm._v(" "), _c('option', [_vm._v("Asia/Kolkata")]), _vm._v(" "), _c('option', [_vm._v("Asia/Bangkok")]), _vm._v(" "), _c('option', [_vm._v("Asia/Shanghai")]), _vm._v(" "), _c('option', [_vm._v("Asia/Kuala_Lumpur")]), _vm._v(" "), _c('option', [_vm._v("Asia/Ho_Chi_Minh")]), _vm._v(" "), _c('option', [_vm._v("Asia/Seoul")]), _vm._v(" "), _c('option', [_vm._v("Asia/Tokyo")]), _vm._v(" "), _c('option', [_vm._v("Australia/Hobart")]), _vm._v(" "), _c('option', [_vm._v("Australia/Sydney")]), _vm._v(" "), _c('option', [_vm._v("Australia/Brisbane")]), _vm._v(" "), _c('option', [_vm._v("Australia/Perth")]), _vm._v(" "), _c('option', [_vm._v("America/New_York")]), _vm._v(" "), _c('option', [_vm._v("America/Monterrey")]), _vm._v(" "), _c('option', [_vm._v("America/Halifax")]), _vm._v(" "), _c('option', [_vm._v("America/Argentina/Cordoba")]), _vm._v(" "), _c('option', [_vm._v("America/Fortaleza")]), _vm._v(" "), _c('option', [_vm._v("America/Sao_Paulo")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoSetTimeZone
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-restart-device"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Restart")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right alert-del"
  }, [_vm._m(25), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.toRestartDevice
    }
  }, [_vm._v("Restart")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("Active Accessories:  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "parameter-setting-box-body-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o text-yellow parameter-setting-label"
  }), _c('span', {
    staticClass: "parameter-setting-box-body-title"
  }, [_vm._v("Active Accessories:  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Duress Alarm Setting")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-3 control-label agent-edit-modal-name"
  }, [_vm._v("Duress Alarm")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 modal-parameter-setting-switch"
  }, [_c('input', {
    staticClass: "switch-checkbox",
    attrs: {
      "type": "checkbox",
      "id": "alarm_setting_switch",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Customize Home Arm function")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-pir"
  }), _vm._v("PIR Motion Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-door"
  }), _vm._v("Door/Window Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-pir"
  }), _vm._v("PIR Motion Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-door"
  }), _vm._v("Door/Window Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Entry Delay")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-pir"
  }), _vm._v("PIR Motion Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-door"
  }), _vm._v("Door/Window Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-pir"
  }), _vm._v("PIR Motion Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-square device-setting-modal-plugin-type-door"
  }), _vm._v("Door/Window Sensor")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Exit Delay")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Siren Duration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Siren Duration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Restart the Device")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "firmware-version-update"
  }, [_c('p', [_vm._v("After RESTART, the local data and configure of the device will be updated to the Server. It may take several minutes.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "icon fa fa-warning alert-del-warning"
  }), _vm._v("Confirm to Restart ?")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-13f31dba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13f31dba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ParameterSetting.vue
// module id = 457
// module chunks = 1